<script setup lang="ts">
import ConnxIcon from '../Atoms/ConnxIcon.vue';
import type AvailableIcons from '@/interfaces/AvailableIcons';
import AlertType from '@/interfaces/AlertType';

interface Props {
  type: AlertType;
}

let cssClass = '';
let iconName: AvailableIcons = 'far fa-times-circle';
const props = defineProps<Props>();

switch (props.type) {
  case ('error'):
    cssClass = 'tw-bg-connx-danger';
    iconName = 'far fa-times-circle';
    break;
  case ('warning'):
    cssClass = 'tw-bg-connx-warning';
    iconName = 'far fa-exclamation-triangle';
    break;
  case ('info'):
    cssClass = 'tw-bg-connx-info';
    iconName = 'far fa-info-circle';
    break;
  case ('success'):
  default:
    cssClass = 'tw-bg-connx-success';
    iconName = 'far fa-check';
    break;
}
</script>

<template>
  <div
    class="tw-rounded tw-py-3 tw-px-4 tw-text-connx-white tw-inline-flex tw-items-center tw-leading-tight"
    :class="cssClass"
  >
    <div class="tw-flex-shrink-0 tw-mr-4">
      <connx-icon
        :name="iconName"
        class="tw-h-6 tw-w-auto"
      />
    </div>
    <slot></slot>
  </div>
</template>
